import { FundClassification } from '@/models/common/FundClassification';
import { FundStatus } from '@/models/common/FundStatus';
import { FundFeatures } from '@/models/common/FundFeatures';
import { FundCoordinatorDtoOut } from '@/models/out/FundCoordinatorDtoOut';

export interface FundManagementSupported {
  id?: number;
  israeliId: string;
  firstName: string;
  lastName: string;
  city?: string | null;
  street?: string | null;
  houseNumber?: string | null;
  email?: string | null;
  phone?: string | null;
  additionalInfo?: string | null;
}

export interface FundManagementDocument {
  name: string;
  description?: string | null;
  uri: string;
  creationTime: string;
}

export interface BalancesByKindDtoIn {
  commissions: number;
  donations: number;
  loans: number;
  deposits: number;
  supports: number;
  scholarships: number;
  suppliersHok: number;
  suppliersNotHok: number;
  expenses: number;
  other: number;
  total: number;
}

export interface SupportRequestsBalancesDtoIn {
  canRequestSupport: boolean;
  pendingExecutionSum: number;
  pendingExecutionSumSingleMonth: number;
  pendingExecutionSumMultiMonth: number;
  frozenRequestsSum: number;
}

export interface FundBalancesDtoIn {
  fundId: number;
  fundName: string;
  balancesByKind: BalancesByKindDtoIn;
  supportRequestsBalances: SupportRequestsBalancesDtoIn;
  overdraftAmount: number;
  nedarimDevicesFreezeAmount: number;
  currency?: string | null;
}

/** HAT-1301: what the office sees on a frozen fund's card - who sent what, ready to approve or decline. */
export interface PendingReactivationDtoIn {
  submittedByEmail: string;
  submittedAt: string;
  documents: FundManagementDocument[];
}

export interface FundManagementDetailsDtoIn {
  id: number;
  name: string;
  fundBalances?: FundBalancesDtoIn | null;
  classification: FundClassification;
  internalClassification?: string | null;
  status: FundStatus;
  /** HAT-1301: when the fund was frozen for inactivity; null unless status is Frozen. */
  frozenAt?: string | null;
  /** HAT-1301: identity documents the coordinator sent to bring this frozen fund back, waiting for the office. */
  pendingReactivation?: PendingReactivationDtoIn | null;
  supporteds?: FundManagementSupported[] | null;
  coordinators?: FundCoordinatorDtoOut[] | null;
  documents?: FundManagementDocument[] | null;
  features?: FundFeatures | null;
}

export const calculateAvailableBalance = (balances: FundBalancesDtoIn): number =>
  balances.balancesByKind.total
  - balances.supportRequestsBalances.pendingExecutionSum
  - balances.overdraftAmount
  - balances.nedarimDevicesFreezeAmount
  - balances.supportRequestsBalances.frozenRequestsSum;
